import { Link } from 'react-router';
import normalize from 'components/Dashboard/utilities/normalizeString';
import { useHeightContainer } from 'components/Dashboard/utilities/useHeightContainer';
import time from 'utils/time';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { useContext } from 'react';
import { store } from 'components/Store';
import CustomScrollbar from 'components/Common/CustomScrollbar';
import useTopicOrClientWord from 'components/Dashboard/hooks/useTopicOrClientWord';
import CreditsButton from 'components/Dashboard/components/CreditsButton';

const MyContent = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { team } = state ?? {};
  const { results, isLoading, individualPage } = props;
  const [heightContainer, containerRef] = useHeightContainer();
  const { newAgencyPlan } = useTopicOrClientWord();

  return (
    <>
      <div className='flex-grow-1'>
        <CustomScrollbar className={'simple-scrollbar'} maximalThumbYSize={100}>
          {!individualPage && (
            <div className='main-sticky z-200'>
              <div
                className={`bg-white general-subnav inbox-items-bar trends-subnav-bar position-relative z-10`}
                style={{ minHeight: '147px' }}
              >
                <div className='mx-auto main-content-wrapper px-lg-5 px-3 pt-2'>
                  <div className={`flex-centered`}>
                    <span className='icon-bot title-h2 inline-block mr-3' />
                    <SubNavText />
                  </div>
                </div>
                <div className='mx-auto main-content-wrapper overflow-auto px-lg-5 px-3 pb-4'>
                  <AIAssistantCreateButtons />
                </div>
              </div>
              <div className='mx-auto main-content-wrapper px-lg-5 px-3 flex-centered justify-content-between flex-wrap bg-grey py-3 pt-lg-4'>
                <h3 className='title-h4-bold mb-0'>My team's previous responses</h3>
              </div>
            </div>
          )}

          <div
            className={`mx-auto main-content-wrapper ${
              individualPage ? 'px-3 pl-lg-4 pr-lg-5 pt-2' : 'px-lg-5 px-3'
            } d-flex flex-column`}
          >
            <div
              ref={containerRef}
              className={`box-top-rounded specific-y-padding-lg-16 specific-x-padding-lg-16 specific-y-padding-lg-34 specific-x-padding-lg-34  writing-my-content`}
              style={{ minHeight: `${heightContainer}px` }}
            >
              {isLoading ? (
                <SkeletonContent />
              ) : (
                <>
                  {results?.length > 0 ? (
                    <ul className='policy-list px-0 items-list'>
                      {results?.map((item) => {
                        const { id, contentType, title, createdAt, authorName } = item;
                        return (
                          <Link
                            to={`/ai-assistant/content/${id}`}
                            state={{ influencePage: individualPage }}
                            className={`content-item-link my-2`}
                            key={`item-${contentType}-${id}`}
                          >
                            <li className={`p-3`}>
                              <div className='pl-1 ai-assistant-list-item'>
                                <p className='mb-0 light-65-text ai-assistant-list-item-date'>
                                  {authorName}
                                  <span className='heading-date'>
                                    <span className='dot light-65-text' />
                                  </span>{' '}
                                  {time(createdAt).formatGeneralDate()}
                                </p>
                                <p className='ai-assistant-list-item-title specific-top-margin-8 hidden-lines hidden-one-line  text-main-blue mb-0 '>
                                  {title}
                                </p>
                              </div>
                            </li>
                          </Link>
                        );
                      })}
                    </ul>
                  ) : (
                    <div className='empty-state-grid-item text-center' style={{ marginTop: '175px' }}>
                      <p
                        className='title-h4 text-center main-light-text mb-0 text-center mx-auto'
                        style={{ maxWidth: '500px' }}
                      >
                        You haven’t written anything with PolicyMogul’s AI assistant yet{' '}
                        {newAgencyPlan ? `for ${team?.teamName}` : ''}
                      </p>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </CustomScrollbar>
      </div>
    </>
  );
};

const AIAssistantCreateButtons = (props) => {
  const { influencePage } = props;
  const { agencyUser, newAgencyPlan } = useTopicOrClientWord();
  const createTypes = () => {
    const types = ['response to a constituent'];
    return types;
  };
  const types = createTypes();
  return (
    <div className={`specific-top-padding-20 d-flex writing-creation-buttons`}>
      {types.map((item) => {
        const responseConstituent = item === 'response to a constituent';
        return (
          <Link
            key={`item-${normalize(item)}`}
            className={`nowrap-item creation-button py-1 px-3 mr-lg-3 py-lg-2 action-button rounded-button ${
              responseConstituent ? 'px-lg-4' : 'px-lg-5'
            } mr-2`}
            to={{
              pathname: `${
                influencePage && !(item === 'email to parliamentarians' && (agencyUser || newAgencyPlan))
                  ? `/brief-policymakers/ai/${normalize(item)}`
                  : `/ai-assistant/create/${normalize(item)}`
              }`,
              state: { influencePage: influencePage },
            }}
          >
            {responseConstituent && 'Respond to a constituent'}
          </Link>
        );
      })}
    </div>
  );
};

const SkeletonContent = () => {
  return (
    <SkeletonTheme baseColor='#f2f2f2'>
      <div>
        <ul className='policy-list px-0 items-list'>
          {Array(5)
            .fill()
            .map((item, index) => (
              <li className={`my-2`} key={index}>
                <div className='p-3 align-items-center'>
                  <div className='pr-lg-5 pr-2 pl-0'>
                    <Skeleton height={19} width={`80%`} />
                    <Skeleton height={19} width={`30%`} />
                  </div>
                </div>
              </li>
            ))}
        </ul>
      </div>
    </SkeletonTheme>
  );
};

const SubNavText = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { remainingCredits } = state;

  const { showCredits } = props;

  return (
    <>
      <div className='flex-centered justify-content-between flex-grow-1'>
        <p className='mb-0'>
          PolicyMogul’s AI assistant is used by policymakers and staff to respond to emails from constituents and
          others.{' '}
        </p>
        {remainingCredits >= 0 && showCredits && <CreditsButton type={'AI'} hideDots={true} />}
      </div>
    </>
  );
};

export { SubNavText, SkeletonContent, AIAssistantCreateButtons };
export default MyContent;
